import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "./api";

export const usePickupDays = () => {
  const [state, setState] = useState({ days: [], status: "loading" });
  useEffect(() => {
    if (!API) {
      setState({ days: [], status: "error" });
      return undefined;
    }
    let alive = true;
    axios
      .get(`${API}/pickup-slots`)
      .then((r) => {
        const days = Array.isArray(r.data?.days) ? r.data.days.filter((d) => Array.isArray(d?.slots) && d.slots.length) : [];
        if (alive) setState({ days, status: "ready" });
      })
      .catch(() => {
        if (alive) setState({ days: [], status: "error" });
      });
    return () => {
      alive = false;
    };
  }, []);
  return state;
};
